import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { createNaverMap } from 'vue3-naver-maps';
import '@/assets/css/main.scss';

const pinia = createPinia();
const app = createApp(App);

app.use(createNaverMap, {
    clientId: process.env.VUE_APP_NAVER_MAP_CLIENT_ID,
    enableAiMaps: false,
})
    .use(router)
    .use(pinia)
    .mount('#app');
